export default __webpack_public_path__ + "static/media/logo2.2b1a481c.svg";